function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { ManifestComponentExtensionType } from '../ManifestStore';
var _state = /*#__PURE__*/new WeakMap();
export class StandaloneManifestRuntimeContextBuilder {
  constructor() {
    _classPrivateFieldInitSpec(this, _state, {
      manifests: [],
      handlers: {
        styles: {
          getStyles: () => Promise.resolve({}),
          setStyles: () => Promise.resolve(),
          removeStyles: () => Promise.resolve(),
          getDefaultCssPropertyValue: () => undefined,
          getDefaultCustomCssPropertyValue: () => undefined
        },
        data: {
          getData: () => Promise.resolve({}),
          setData: () => Promise.resolve(),
          getDefaultValue: () => undefined
        },
        resolvedData: {
          getVectorArtResolvedData: () => undefined
        },
        state: {
          getViewStates: () => ({}),
          getViewState: () => null,
          setViewState: () => null,
          getState: () => null,
          setState: () => {},
          getGlobalStates: () => []
        },
        presets: {
          getAppliedPreset: () => null,
          applyPreset: () => undefined
        },
        layout: {
          applyComponentResize: () => undefined
        }
      }
    });
  }
  withStyleHandlers(handlers) {
    _classPrivateFieldGet(_state, this).handlers.styles = {
      getStyles: (_editorPointer, _type) => {
        return handlers.getStyles();
      },
      setStyles: (_editorPointer, _type, styles) => {
        return handlers.setStyles(styles);
      },
      removeStyles: (_editorPointer, _type, styles) => {
        return handlers.removeStyles(styles);
      },
      getDefaultCssPropertyValue: (_editorPointer, _type, key) => {
        return handlers.getDefaultValue(key);
      },
      getDefaultCustomCssPropertyValue: (_editorPointer, _type, key) => {
        return handlers.getDefaultValue(key);
      }
    };
    return this;
  }
  withEditorElement(editorElement) {
    _classPrivateFieldGet(_state, this).manifests.push({
      editorElement
    });
    return this;
  }
  build(manifestId) {
    var _manifest$editorEleme, _manifest$editorEleme2;
    // if (!this.#state.handlers) {
    //   throw createEditorPlatformManifestServicesError(
    //     EditorPlatformManifestServicesErrorCode.ManifestContextBuild,
    //     'handlers are required for RawManifestRuntimeContextBuilder',
    //   ).withMessage('probably builder.withHandlers was not called');
    // }

    const manifest = _classPrivateFieldGet(_state, this).manifests[0];
    const editorPointer = {
      documentPointer: {
        id: 'UNEXISTING_COMPONENT'
      }
    };

    /**
     * at the current stage, for this builder, we do not support:
     * - multiple manifests within the same context
     * - children
     * - mappings
     * - linked items
     * - data
     */
    return {
      manifestId,
      isStageBound: false,
      tree: {
        editorPointer: null,
        extensionType: null,
        manifest,
        /**
         * According to the new manifest structure,
         * we need to be able to disable mapping by setting it to null
         */
        mappings: {
          cssProperties: Object.keys((manifest == null || (_manifest$editorEleme = manifest.editorElement) == null ? void 0 : _manifest$editorEleme.cssProperties) ?? {}).reduce((acc, key) => {
            return {
              ...acc,
              [key]: [{
                editorPointer,
                key,
                extensionType: ManifestComponentExtensionType.UNKNOWN
              }]
            };
          }, {}),
          cssCustomProperties: Object.keys((manifest == null || (_manifest$editorEleme2 = manifest.editorElement) == null ? void 0 : _manifest$editorEleme2.cssCustomProperties) ?? {}).reduce((acc, key) => {
            return {
              ...acc,
              [key]: [{
                editorPointer,
                key,
                extensionType: ManifestComponentExtensionType.UNKNOWN
              }]
            };
          }, {}),
          data: {},
          actions: {},
          customActions: {},
          presets: {},
          states: {},
          layout: {}
        },
        children: []
      },
      manifests: [{
        store: {
          extensionType: ManifestComponentExtensionType.UNKNOWN,
          manifest,
          metadata: null
        },
        editorPointer
      }],
      handlers: _classPrivateFieldGet(_state, this).handlers
    };
  }
}
//# sourceMappingURL=StandaloneManifestRuntimeContextBuilder.js.map